import classNames from 'classnames';
import { Outlet } from 'react-router-dom';

import usePlatform from '@/hooks/use-platform';
import { layoutClassNames } from '@/utils/consts';

import CartoonPanel from './CartoonPanel';
import CustomContent from './CustomContent';
import styles from './index.module.scss';

const AppLayout = () => {
  const { isMobile } = usePlatform();

  return (
    <div className={styles.viewBox}>
      <div className={classNames(styles.container, layoutClassNames.pageContainer)}>
        {!isMobile && <CartoonPanel className={styles.cartoonPanel} />}
        <div className={styles.formColumn}>
          {!isMobile && <CustomContent className={layoutClassNames.customContent} />}
          <main className={classNames(styles.main, layoutClassNames.mainContent)}>
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
};

export default AppLayout;
